export const config = {
  apiKey: "AIzaSyDsHVWh0ON7gYlBRFbxQJj9vGxfqCYANTE",
  authDomain: "taxscribe-gov-production.firebaseapp.com",
  projectId: "taxscribe-gov-production",
  storageBucket: "taxscribe-gov-production.appspot.com",
  messagingSenderId: "469188296144",
  appId: "1:469188296144:web:c3d908ceb4af6343db8dd5",
  measurementId: "G-HFXD9B6HY5"
};
